import { render, staticRenderFns } from "./DropdownPopover.vue?vue&type=template&id=37ea1e07&"
import script from "./DropdownPopover.vue?vue&type=script&lang=js&"
export * from "./DropdownPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports